var map = {
	"./sms-credit-de.html": 1966,
	"./sms-credit-en.html": 1967,
	"./sms-credit-es.html": 1968,
	"./sms-credit-fr.html": 1969,
	"./sms-credit-ja.html": 1970,
	"./sms-credit-pt.html": 1971,
	"./sms-credit-zh.html": 1972
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1965;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-credit ^\.\/sms\-credit\-.*\.html$
// module id = 1965
// module chunks = 0